import { render, staticRenderFns } from "./gs.vue?vue&type=template&id=17339c8a&scoped=true&"
import script from "./gs.vue?vue&type=script&lang=js&"
export * from "./gs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17339c8a",
  null
  
)

export default component.exports